<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style lang="less">
  * {
    padding: 0;
    margin: 0;
  }

  html, body {
    min-height: 100vh;
  }

  /* 提示框 */
  .tool-message-box {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 6px;
    padding: 12px 20px;
    max-width: 80vw;
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    background: rgba(0, 0, 0, .75);
  }


  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    background: #F2F2F2;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue